import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { getHouseReviewCountAndRating } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getSellerUrl } from '@/utils/urls';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { openReviewsModal } from '@/redux/modules/modal';
import { StarRating } from '@liveauctioneers/hammer-ui-core/starRating';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useMemo } from 'react';
import { WeakRouteLink } from '@/components/RouteLinks/RouteLinks';

export type CardHouseAndRatingProps = {
    itemId: number;
    onNavigate?: (trigger: ItemCardNavigationTrigger) => void;
};

const MAX_REVIEW_COUNT = 1000;

const CardHouseAndRating = ({ itemId, onNavigate }: CardHouseAndRatingProps) => {
    const dispatch = useAppDispatch();
    const { houseRating, houseReviewCount, sellerId, sellerName } = useAppSelector((state) =>
        getHouseReviewCountAndRating(state, itemId)
    );

    const trailingText = useMemo(() => {
        if (houseReviewCount > MAX_REVIEW_COUNT) {
            const countInThousands = Math.floor(houseReviewCount / 100) / 10;
            return `${countInThousands}k`;
        }
        return houseReviewCount?.toString();
    }, [houseReviewCount]);

    return (
        <div className="grid grid-cols-[1fr_min-content] gap-2xs">
            <WeakRouteLink
                className="truncate text-link-secondary no-underline hover:[&>span]:text-[var(--color-link-primary)] hover:[&>span]:underline"
                data-testid="cardInfoAuctionHouseName"
                onClick={() => onNavigate?.(ItemCardNavigationTrigger.HouseNameClick)}
                to={getSellerUrl(sellerId, sellerName)}
            >
                <BodySecondary color="secondary">{sellerName}</BodySecondary>
            </WeakRouteLink>
            {houseReviewCount > 0 && (
                <StarRating
                    averageRating={houseRating}
                    compact
                    onClick={() => dispatch(openReviewsModal(sellerId))}
                    trailingText={trailingText}
                />
            )}
        </div>
    );
};

export default CardHouseAndRating;
